import { ResetState } from './stateTypes';

export type CasinoActionType = ResetState | SetCasinoNetPosition;

export const SET_CASINO_NET_POSITION = 'SET_CASINO_NET_POSITION';

export interface CasinoState {
  casinoNetPosition: number;
}

interface SetCasinoNetPosition {
  type: typeof SET_CASINO_NET_POSITION;
  meta: number;
}
